export default "__VITE_ASSET__DvMHLbGT__"